import Vue from 'vue';
import Router from 'vue-router';
import {Storage} from '@/utils/common';

// 获取原型对象的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);
export const creatRouters = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('@/pages/login/login')
  },
  {
    path: '/reset-pwd',
    component: () => import('@/pages/login/resetPwd')
  },
  {
    path: '/large-screen',
    component: () => import('@/pages/large-screen')
  }
];

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: creatRouters,
    base: ''
  });

const router = createRouter();

// 不需要重定向到登录页面的路径
const whiteList = ['/login', '/reset-pwd', '/large-screen'];
// 检查一个路径是否需要重定向
const needsRedirect = (path) => {
  if (whiteList.includes(path)) return false;
  return '/';
};

// 路由拦截
router.beforeEach((to, from, next) => {
  const token = Storage.get('token');
  if (!token) {
    const redirectPath = needsRedirect(to.path);
    if (redirectPath) {
      next(redirectPath);
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
